import { Table } from "antd";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import BannerCard from "../../common/components/BannerCard";
import CleanButton from "../../common/components/CleanButton";
import Page from "../../common/components/Page";
import PDFModal from "../../common/components/PDFModal";
import useTrafficCriminalLookup from "./useTrafficCriminalLookup";
import HCaptcha from "@hcaptcha/react-hcaptcha";

interface StateType {
  state: {
    returnData?: any;
    condition?: string;
    search?: string;
    returnStatus?: boolean;
  };
  key: string;
  pathname: string;
  search: string;
  hash: string;
}

const TrafficCriminalLookup = () => {
  const {
    data,
    setCondition,
    setSearch,
    handleSearch,
    columns,
    loading,
    setData,
    search,
    condition,
    returnStatus,
    handleNewQuery,
    setReturnStatus,
    fixedColumns,
    fixedData,
    handleViewPDF,
    visibility,
    setVisibility,
    searchCaptcha,
    validateSearchCaptcha
  } = useTrafficCriminalLookup();
  const location = useLocation();

  useEffect(() => {
    const stateObject: StateType = { ...location };
    if (stateObject.state && stateObject.state.returnData) {
      setData(stateObject.state.returnData);
      setCondition(stateObject.state.condition);
      setSearch(stateObject.state.search);
      setReturnStatus(stateObject.state.returnStatus);
    } else {
      setData(null);
      setCondition("name");
      setSearch(null);
      setReturnStatus(false);
    }
  }, [location, setCondition, setData, setReturnStatus, setSearch]);

  return (
    <Page>
      <Page.Title title="Traffic/Criminal Case Lookup" icon="search" />
      <Page.Controls
        onConditionChange={setCondition}
        conditionValue={condition}
        conditionSearch={search}
        onSearchChange={(e) => setSearch(e.target.value)}
        onSearch={validateSearchCaptcha}
        onNewSearch={handleNewQuery}
        isReturn={returnStatus}
        loading={loading}
      />
      <Page.Content>
        {data && data.length ? (
          <>
            <CleanButton onClick={handleViewPDF} icon="eye" loading={visibility}>
              View PDF
            </CleanButton>
            <Table loading={visibility ? visibility : loading} size="small" columns={columns} dataSource={data} scroll={{ x: 720 }} />
            <PDFModal visibility={visibility} setVisibility={setVisibility} data={data} fromScreen="TCL" />
          </>
        ) : (
          <BannerCard title="Description of lookup option(s)">
            <Table size="small" columns={fixedColumns} dataSource={fixedData} pagination={false} />
          </BannerCard>
        )}
        <HCaptcha
          sitekey="18b76bdc-7767-4393-8519-6f95a63e23bb"
          onVerify={handleSearch}
          //onClose={() => setLoading(false)}
          size="invisible"
          ref={searchCaptcha}
        />
      </Page.Content>
    </Page>
  );
};

export default TrafficCriminalLookup;
